import { PropsWithChildren, useMemo, useState } from 'react';

import { TargetModel } from '../../../modules/Apps';
import { createNullableContext, useNullableContext } from '../../../utils/Context';
import { PopoverStateReturn } from '../../common/Drawer/Drawer.context';

interface TargetsTableContextValues {
  createTargetDrawerState: PopoverStateReturn;
  editTargetDrawerState: PopoverStateReturn;
  viewTargetDrawerState: PopoverStateReturn;
  editingTarget?: TargetModel;
  setEditingTarget: (value?: TargetModel) => void;
}

interface TargetsTableContextProviderProps {
  createTargetDrawerState: PopoverStateReturn;
  editTargetDrawerState: PopoverStateReturn;
  viewTargetDrawerState: PopoverStateReturn;
}

export const TargetsTableContext =
  createNullableContext<TargetsTableContextValues>('TargetsTableContext');

export const useTargetsTableContext = () => useNullableContext(TargetsTableContext);

export const TargetsTableContextProvider = ({
  children,
  createTargetDrawerState,
  editTargetDrawerState,
  viewTargetDrawerState,
}: PropsWithChildren<TargetsTableContextProviderProps>) => {
  const [editingTarget, setEditingTarget] = useState<TargetModel | undefined>();

  const value = useMemo(
    () => ({
      createTargetDrawerState,
      editTargetDrawerState,
      viewTargetDrawerState,
      editingTarget,
      setEditingTarget,
    }),
    [createTargetDrawerState, editTargetDrawerState, editingTarget, viewTargetDrawerState],
  );

  return <TargetsTableContext.Provider value={value}>{children}</TargetsTableContext.Provider>;
};
